import { collectSlides } from './collect-slides';

/**
 * Dynamically loads and sorts presentation slides from a specified folder
 * @param folder - The presentation folder name to load slides from
 * @returns Promise<Array<() => ReactElement>> - Array of slide component functions
 */
export const loadSlides = async (folder: string) => {
  // Use Vite's import.glob to dynamically import all TSX files in presentations directory
  // eager: true ensures synchronous loading of all matching modules
  const modules = import.meta.glob('/presentations/**/*.tsx', { eager: true });
  return collectSlides(modules, folder);
};
